function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Car3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M135.063,150.473A33.115,33.115,0,0,1,165.135,131h.014l222.815.151a32.852,32.852,0,0,1,11.161,1.971l-.9-2.086a33.018,33.018,0,0,0-30.256-19.885L145.149,111h-.014a33.115,33.115,0,0,0-30.072,19.473L95.211,174.437A32.029,32.029,0,0,1,96.741,181h24.538Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.138,283.179c.089.058.183.115.272.173,1.675-7.659,5.249-21.279,8.592-33.076C68.463,231.154,89.882,215,109.772,215H442.165a46.809,46.809,0,0,1,23.2,6.757C456.942,206.591,439,195,422.165,195H89.772c-19.89,0-41.309,16.154-46.77,35.276-4.148,14.639-8.655,32.091-9.442,37.468,2.573,2.988,11.555,9.771,20.474,15.424C54.068,283.19,54.1,283.156,54.138,283.179Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,347.337v-41.57c3.486,2.644,7.9,5.592,13.491,9.138,20.3,13.352,56.535,24.1,80.811,24.1h7.554a30.546,30.546,0,0,1-2.235-5.135L147.79,319H127.3c-24.276,0-60.509-10.743-80.811-24.1-5.6-3.546-10.005-6.494-13.491-9.138v41.57a34.581,34.581,0,0,0,22.256,32.3A34.471,34.471,0,0,1,53,347.337Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.819,263.967A25.887,25.887,0,1,0,91.705,238.08,25.916,25.916,0,0,0,65.819,263.967ZM91.705,252.08a11.887,11.887,0,1,1-11.886,11.887A11.9,11.9,0,0,1,91.705,252.08Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.3,289.853a25.887,25.887,0,1,0-25.887-25.886A25.916,25.916,0,0,0,420.3,289.853Zm0-37.773a11.887,11.887,0,1,1-11.887,11.887A11.9,11.9,0,0,1,420.3,252.08Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.43,422A17.829,17.829,0,0,0,123,404.53V369.306a7,7,0,0,0-14,0V404.53a3.85,3.85,0,0,1-3.57,3.47H74.2a3.509,3.509,0,0,1-3.2-3.47V369.306a7,7,0,0,0-14,0V404.53A17.509,17.509,0,0,0,74.2,422Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.349,422H437.8A17.507,17.507,0,0,0,455,404.53V369.306a7,7,0,0,0-14,0V404.53a3.507,3.507,0,0,1-3.2,3.47H404.349A3.64,3.64,0,0,1,401,404.53V369.306a7,7,0,0,0-14,0V404.53A17.636,17.636,0,0,0,404.349,422Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.853,252H136.15a7,7,0,1,0,0,14h239.7a7,7,0,1,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.853,275H136.15a7,7,0,1,0,0,14h239.7a7,7,0,1,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,160a33.092,33.092,0,0,1,32.329,26.341c.17.832.31,1.681.415,2.525A7,7,0,0,0,202.682,195a7.21,7.21,0,0,0,.875-.054,7,7,0,0,0,6.079-7.813c-.149-1.2-.348-2.412-.591-3.6a47.008,47.008,0,0,0-92.581,2.84,7,7,0,1,0,13.862,1.958A33.127,33.127,0,0,1,163,160Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.819,263.967A25.887,25.887,0,1,0,91.705,238.08,25.916,25.916,0,0,0,65.819,263.967ZM91.705,252.08a11.887,11.887,0,1,1-11.886,11.887A11.9,11.9,0,0,1,91.705,252.08Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.3,289.853a25.887,25.887,0,1,0-25.887-25.886A25.916,25.916,0,0,0,420.3,289.853Zm0-37.773a11.887,11.887,0,1,1-11.887,11.887A11.9,11.9,0,0,1,420.3,252.08Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.43,422A17.829,17.829,0,0,0,123,404.53V369.306a7,7,0,0,0-14,0V404.53a3.85,3.85,0,0,1-3.57,3.47H74.2a3.509,3.509,0,0,1-3.2-3.47V369.306a7,7,0,0,0-14,0V404.53A17.509,17.509,0,0,0,74.2,422Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.349,422H437.8A17.507,17.507,0,0,0,455,404.53V369.306a7,7,0,0,0-14,0V404.53a3.507,3.507,0,0,1-3.2,3.47H404.349A3.64,3.64,0,0,1,401,404.53V369.306a7,7,0,0,0-14,0V404.53A17.636,17.636,0,0,0,404.349,422Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.853,252H136.15a7,7,0,1,0,0,14h239.7a7,7,0,1,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.853,275H136.15a7,7,0,1,0,0,14h239.7a7,7,0,1,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,160a33.092,33.092,0,0,1,32.329,26.341c.17.832.31,1.681.415,2.525A7,7,0,0,0,202.682,195a7.21,7.21,0,0,0,.875-.054,7,7,0,0,0,6.079-7.813c-.149-1.2-.348-2.412-.591-3.6a47.008,47.008,0,0,0-92.581,2.84,7,7,0,1,0,13.862,1.958A33.127,33.127,0,0,1,163,160Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.381,226.375c-3.5-12.167-11.681-23.22-22.154-31.375H483a7,7,0,0,0,7-7,32.036,32.036,0,0,0-32-32h-3a31.958,31.958,0,0,0-25.292,12.43l-18.647-42.939a47.041,47.041,0,0,0-43.092-28.34L145.154,97h-.019a47.139,47.139,0,0,0-42.829,27.708L85.99,160.845A31.834,31.834,0,0,0,65,153H62a32.036,32.036,0,0,0-32,32,7,7,0,0,0,7,7H55.854c-12.46,8.34-22.386,20.681-26.317,34.445-6.965,24.576-9.23,35.106-9.861,39.979A6.958,6.958,0,0,0,19,269.409v57.928A48.764,48.764,0,0,0,67.969,376H444.031A48.764,48.764,0,0,0,493,327.337V269.409a6.967,6.967,0,0,0-.391-2.289C492.191,262.153,489.984,251.5,482.381,226.375ZM455,170h3a18.027,18.027,0,0,1,16.583,11H438.417A18.027,18.027,0,0,1,455,170ZM115.063,130.473A33.115,33.115,0,0,1,145.135,111h.014l222.815.151a33.018,33.018,0,0,1,30.256,19.885L419.9,181H96.741a32.029,32.029,0,0,0-1.53-6.563ZM62,167h3A17.989,17.989,0,0,1,79.746,174.7L78.252,178H45.417A18.027,18.027,0,0,1,62,167ZM43,230.276C48.463,211.154,69.882,195,89.772,195H422.165c19.882,0,41.3,16.156,46.771,35.279l.03.1c4.341,14.343,9,31.633,9.686,37.026-2.728,3.188-12.006,10.261-19.829,15.588-17.965,11.989-51.391,22-72.992,22H127.3c-21.612,0-55.116-9.931-73.164-21.821-.034-.023-.07.011-.1-.011-8.919-5.653-17.9-12.436-20.474-15.424C34.347,262.367,38.854,244.915,43,230.276ZM337.445,319l-3.554,10.515C331.279,337.2,321.869,344,313.754,344H185.806c-8.079,0-17.368-6.8-19.876-14.481L162.517,319Zm106.586,43H67.969A34.748,34.748,0,0,1,33,327.337v-41.57c3.486,2.644,7.9,5.592,13.491,9.138,20.3,13.352,56.535,24.1,80.811,24.1H147.79l4.831,14.865c4.41,13.5,18.986,24.135,33.185,24.135H313.754c14.164,0,28.831-10.568,33.392-23.978L352.233,319h33.6c24.313,0,60.544-10.865,80.816-24.4,4.771-3.247,8.89-6.12,12.353-8.841v41.574A34.748,34.748,0,0,1,444.031,362Z",
    style: {
      fill: "#2f55d4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.cd0e06f3b466a3da64b667d5837255f4.svg";
export { ForwardRef as ReactComponent };